<h5>{{tituloFirma}}</h5>
<p style="font-weight: 500;">Emplazamiento del campo de firma</p>
<p>¿Cómo se emplazará su firma en el documento?</p>
<form [formGroup]="formFirma">
  <div class="emplazamiento-con-validacion">
    <div class="input-firmante">
      <div class="input-radio">
        <input type="radio" name="tieneTag" formControlName="tieneTag" [value]=false>
      </div>

      <label for="tieneTag">Trazarlo en el documento</label>
    </div>
    <div class="input-firmante" style="margin-top: 10px">
      <div class="input-radio">
        <input type="radio" name="tieneTag" formControlName="tieneTag" [value]=true>
      </div>
      <label for="tieneTag">Mediante tag: emplazar la firma donde se encuentre un texto específico</label>
    </div>
    <ul>
      <li>Tamaño por defecto (modificable mediante petición a nuestro equipo)</li>
      <li>Recomendamos usar el tag (texto específico): “FirmaSqp”.</li>
    </ul>
    <div
      class="texto-validacion emplazamiento-con-validacion__error"
      *ngIf="tieneTag.value == null && mostrarErrorSeleccion">
      Seleccione una opción
    </div>
  </div>
</form>
